import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  CreateOrUpdateLocation,
  CreateOrUpdateLocationRequest,
  GetLocationById,
} from 'src/api/microservices/aggregator'
import { AxiosError } from 'axios'

type GetLocationByIdResponse = {
  data: {
    data: TenantLocation
    type: string
  }
  type: string
}

export const GET_LOCATION_BY_ID_QUERY_KEY = 'get-location-by-id'
export function useGetLocationById({ tenantId, locationId, companyId }) {
  return useQuery<GetLocationByIdResponse, AxiosError<MicroserviceError>>({
    queryKey: [GET_LOCATION_BY_ID_QUERY_KEY, { tenantId, locationId, companyId }],
    queryFn: async () => {
      const [err, response] = await GetLocationById({ tenantId, locationId, companyId })
      if (err) throw err
      return response
    },
    enabled: !!locationId,
  })
}

export function useCreateOrUpdateLocation({ tenantId, onSuccess, ...options }) {
  const queryClient = useQueryClient()
  let { mutateAsync: createOrUpdateLocation, ...rest } = useMutation({
    mutationFn: async (params: CreateOrUpdateLocationRequest[]) => {
      const [err, response] = await CreateOrUpdateLocation(tenantId, params)
      if (err) throw err
      return response
    },
    onSuccess: (data, variables, ctx) => {
      queryClient.invalidateQueries({ queryKey: [GET_LOCATION_BY_ID_QUERY_KEY] })
      onSuccess?.(data, variables, ctx)
    },
    ...options,
  })

  return { createOrUpdateLocation, ...rest }
}
